<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            id="back-to-apoio-btn"
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'profissionaisDeApoio' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Profissional de Apoio
        </h1>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider name="Nome Completo" rules="required" v-slot="{ errors }">
              <e-label>Nome Completo</e-label>
              <v-text-field
                id="nome-completo"
                :error-messages="errors"
                v-model="form.nome"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label>Email</e-label>
            <v-text-field id="email" v-model="form.email" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <ValidationProvider name="CPF" rules="required" v-slot="{ errors }">
              <e-label>Número do CPF</e-label>
              <v-text-field
                id="cpf"
                :error-messages="errors"
                v-mask="'###.###.###-##'"
                v-model="form.cpf"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Carga horário exercício</e-label>
            <v-text-field id="ch-exercicio" type="number" v-model="form.ch_exercicio" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <ValidationProvider name="Data de nascimento" rules="required" v-slot="{ errors }">
              <e-label>Data de nascimento</e-label>
              <e-date-picker
                id="data-nascimento"
                :error-messages="errors"
                v-model="form.data_nascimento"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <e-label>Filiação 1</e-label>
            <v-text-field id="filiacao1" v-model="form.filiacao1" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <e-label>Filiação 2</e-label>
            <v-text-field id="filiacao2" v-model="form.filiacao2" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Gênero</e-label>
            <e-autocomplete
              id="genero"
              :items="$constants.sexoList"
              :return-object="false"
              :item-value="(value) => value.id"
              :item-text="(value) => value.descricao"
              v-model="form.sexo_id"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Cor/Raça</e-label>
            <e-autocomplete
              id="cor-raca"
              :items="$constants.corOuRacaList"
              :return-object="false"
              v-model="form.cor_ou_raca"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Nacionalidade</e-label>
            <e-autocomplete
              id="nacionalidade"
              :items="$constants.nacionalidadeList"
              :return-object="false"
              v-model="form.naturalidade"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>País de nacionalidade</e-label>
            <v-text-field id="pais-nacionalidade" v-model="form.nacionalidade" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Município de nascimento</e-label>
            <v-text-field id="municipio-nascimento" v-model="form.municipalidade" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>UF de nascimento</e-label>
            <e-autocomplete
              id="uf-nascimento"
              :items="$constants.estadosList"
              :return-object="false"
              :item-text="(item) => item.codigo"
              :item-value="(item) => item.codigo"
              v-model="form.estadualidade"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>

          <v-col class="pt-0 pb-0" cols="8">
            <e-label
              >Profissional escolar com deficiência, transtorno do espectro autista ou altas
              habilidades/superdotação</e-label
            >
            <v-switch id="deficiencia" v-model="form.especial"></v-switch>
          </v-col>
          <v-col cols="12">
            <h4>
              Tipo de deficiência, transtorno do espectro autista ou altas habilidades/superdotação
            </h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Deficiência</e-label>

            <e-autocomplete
              id="tipo-deficiencia"
              clearable
              :items="$constants.tipoDeDeficienciaList"
              :return-object="false"
              v-model="form.tipos_de_deficiencia"
              label="Selecione uma opção"
              multiple
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Transtorno do espectro autista</e-label>

            <e-autocomplete
              id="transtorno"
              clearable
              :items="$constants.tipoDeTranstornoDoEspectroAutistaList"
              :return-object="false"
              v-model="form.tipos_de_transtornos"
              label="Selecione uma opção"
              multiple
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Altas habilidades/superdotação</e-label>

            <e-autocomplete
              id="altas-habilidades"
              clearable
              :items="$constants.tipoDeAltasHabilidadesList"
              :return-object="false"
              v-model="form.tipos_de_altas_habilidades"
              label="Selecione uma opção"
              multiple
              dense
              solo
            />
          </v-col>
          <v-col cols="12">
            <h4>DADOS SOBRE A ÁREA RESIDENCIAL DO(A) PROFISSIONAL(A) ESCOLAR</h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label> CEP </e-label>
            <v-text-field
              id="cep"
              v-mask="'#####-###'"
              v-model="form.cep"
              dense
              solo
              placeholder="00000-000"
              :loading="buscandoCep"
              persistent-hint
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label> País de residência </e-label>
            <v-text-field id="pais-residencia" v-model="form.pais_residencia" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="2">
            <e-label> UF </e-label>
            <e-autocomplete
              id="uf"
              :items="$constants.estadosList"
              :return-object="false"
              :item-text="(item) => item.codigo"
              :item-value="(item) => item.codigo"
              v-model="form.uf_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label> Município de residência </e-label>
            <v-text-field
              id="municipio-residencia"
              value=""
              v-model="form.municipio_residencia"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label> Zona de Residência </e-label>
            <e-autocomplete
              id="zona-residencia"
              :items="$constants.zonaResidenciaList"
              :return-object="false"
              v-model="form.zona_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>

          <v-col class="pt-0 pb-0" cols="12">
            <e-label>Localização diferenciada de residência</e-label>
            <e-autocomplete
              id="localizacao-diferenciada"
              :items="$constants.localizacaoDiferenciadaDeResidenciaList"
              :return-object="false"
              v-model="form.zona_diferenciada_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>

          <v-col class="pt-0 pb-0" cols="12">
            <e-label>Grau Acadêmico</e-label>
            <e-autocomplete
              id="grau-academico"
              :items="grausAcademicos"
              :return-object="false"
              v-model="form.grau_academico_id"
              :item-value="(grau_academico_id) => grau_academico_id.id"
              :item-text="(grau_academico_id) => grau_academico_id.descricao"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>

          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Tipo de Profissional:</e-label>
            <ValidationProvider name="Tipo de Profissional" rules="required" v-slot="{ errors }">
              <e-autocomplete
                id="tipo-profissional"
                :error-messages="errors"
                :items="$constants.rolesParaProfissionaisDeApoio"
                :return-object="false"
                v-model="form.role_id"
                item-value="id"
                item-text="name"
                label="Selecione uma opção"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <v-btn
              id="submit-btn"
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              block
              >Enviar Dados</v-btn
            >
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    roleName: {
      get() {
        this.form.role_id = String(dado.role_id);
        const role = this.$constants.rolesParaProfissionaisDeApoio.find(
          (r) => r.id === this.form.role_id
        );
        return role ? role.name : "";
      },
    },
  },
  mounted() {
    this.loadData();
    if (this.form.role_id) {
      this.form.role_id = String(this.form.role_id);
    }
  },
  beforeDestroy() {
    if (this.cepSearchTimeout) {
      clearTimeout(this.cepSearchTimeout);
    }
  },
  data() {
    return {
      franquiasList: [],
      grausAcademicos: [],
      profissionaisDeApoio: [],
      profissionaisDeApoioList: [],
      carregandoProfissionaisDeApoio: false,
      submittingForm: false,
      form: { user: {} },
      lastCepSearched: null,
      cepSearchTimeout: null,
      buscandoCep: false,
      roles: [],
    };
  },
  watch: {
    "form.cep": {
      async handler(newCep, oldCep) {
        if (this.cepSearchTimeout) {
          clearTimeout(this.cepSearchTimeout);
        }

        if (newCep && newCep !== oldCep && newCep !== this.lastCepSearched) {
          const cepLimpo = newCep.replace(/\D/g, "");

          if (cepLimpo.length === 8) {
            this.cepSearchTimeout = setTimeout(async () => {
              await this.buscarDadosCep(newCep);
            }, 500);
          }
        }
      },
      immediate: false,
    },
  },
  methods: {
    async listarProfissionaisDeApoio() {
      try {
        this.profissionaisDeApoio = await this.$services.profissionaisDeApoioService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
    },

    async submitForm() {
      this.form.especial = Boolean(this.form.especial);
      this.submittingForm = true;
      try {
        if (this.editing) {
          await this.$services.profissionaisDeApoioService.atualizarProfissionalDeApoio(this.form);
          this.$toast.success("Profissional atualizado(a) com sucesso");
        } else {
          await this.$services.profissionaisDeApoioService.criarProfissionalDeApoio(this.form);
          this.$toast.success("Profissional criado(a) com sucesso");
        }
        this.$router.push({ name: "profissionaisDeApoio" });
      } catch (error) {
        this.$handleError(error);
        this.$toast.danger("CPF já cadastrado");
      }
      this.submittingForm = false;
    },

    async loadData() {
      try {
        this.$loaderService.open("Carregando Profissional de Apoio");

        const franquias = await this.$services.franquiasService.listAll();
        this.franquiasList = [...franquias];

        const data = await this.$services.profissionaisDeApoioService.grausAcademicos();

        this.grausAcademicos = [...data];

        const profissional_de_apoio_id = this.$route.params.profissionalDeApoio_id;

        if (profissional_de_apoio_id) this.editing = true;

        if (this.editing) {
          const data = await this.$services.profissionaisDeApoioService.show(
            profissional_de_apoio_id
          );

          const profissionalDeApoio = data.data;

          let franquiasASeremExibidas = [];
          // eslint-disable-next-line
          this.franquiasList.map((f) => {
            // eslint-disable-next-line
            if (profissionalDeApoio?.user?.franquias_permitidas) {
              // eslint-disable-next-line
              if (profissionalDeApoio?.user?.franquias_permitidas?.includes(f.id)) {
                // eslint-disable-next-line
                franquiasASeremExibidas.push(f);
              }
            } else if (this?.user?.franquias_permitidas) {
              // eslint-disable-next-line
              if (this?.user?.franquias_permitidas?.includes(f.id)) {
                // eslint-disable-next-line
                franquiasASeremExibidas.push(f);
              }
            } else {
              franquiasASeremExibidas = [...this.franquiasList];
            }
          });

          this.franquiasList = [...franquiasASeremExibidas];

          if (!this.user.franquias_permitidas) {
            this.franquiasList = [...franquias];
          }

          this.form = {
            ...profissionalDeApoio,
            role_id: String(profissionalDeApoio.role_id),
            user: {
              ...profissionalDeApoio.user,
            },
            franquias_permitidas: profissionalDeApoio?.user?.franquias_permitidas ?? [],
          };
        } else {
          const franquiasASeremExibidas = [];
          // eslint-disable-next-line
          this.franquiasList.map((f) => {
            // eslint-disable-next-line
            if (this.user.franquias_permitidas) {
              // eslint-disable-next-line
              if (this.user.franquias_permitidas.includes(f.id)) {
                franquiasASeremExibidas.push(f);
              }
            }
          });
          this.franquiasList = [...franquiasASeremExibidas];
          if (!this.user.franquias_permitidas) {
            this.franquiasList = [...franquias];
          }
        }

        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async buscarDadosCep(cep) {
      if (!cep || !this.$services.cepService.validarCep(cep)) {
        return;
      }

      try {
        this.buscandoCep = true;
        this.lastCepSearched = cep;
        const localizacao = await this.$services.cepService.buscarDadosDoCep(cep);

        if (this.form.cep === cep) {
          this.form.municipio_residencia = localizacao.cidade;
          this.form.uf_residencia = localizacao.estado;
          this.form.pais_residencia = "Brasil";
        }
      } catch (error) {
        this.$handleError("Erro ao buscar informações do CEP. Verifique se o CEP é válido.");
      } finally {
        this.buscandoCep = false;
      }
    },
  },
};
</script>

<style></style>
